<script lang="ts" setup>
import { cn } from '~/utils';
import SectionContainer from '~/atoms/layouts/SectionContainer';
import SectionWrapper from '~/atoms/layouts/SectionWrapper';
import Icons from '~/icons/Icons.vue';
import ContentContainer from '~/atoms/layouts/ContentContainer';
import ContentWrapper from '~/atoms/layouts/ContentWrapper';
import SubHeaderWrapper from '~/atoms/layouts/SubHeaderWrapper';

useSeoMeta({
  title: 'About Us',
});
</script>

<template>
  <SectionContainer>
    <SectionWrapper>
      <ContentContainer>
        <ContentWrapper
          :class="cn('flex flex-col justify-center gap-5')"
        >
          <SubHeaderWrapper
            :class="cn('mt-4 md:mt-[34px] flex-wrap')"
          >
            <h1 class="text-xxl md:text-xxxl font-bold w-full">
              JUNGLEBET.COM | ABOUT US
            </h1>

            <h2 class="text-xl md:text-xxl font-bold w-full mt-2 md:mt-4">
              Junglebet: Unlock the Ultimate Destination for Crypto Casino and Sports Gambling
            </h2>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              The Ultimate Destination For Gambling
            </h3>

            <p
              class="
                font-normal text-md md:text-base
                col-span-11 leading-normal w-full mt-2
              "
            >
              Step into the future of online <strong>crypto gambling</strong> with <strong>Junglebet</strong>,
              where traditional gaming meets cryptocurrency. Our platform is designed to provide an unparalleled
              experience for both experienced players and newcomers alike.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Cryptocurrencies: An Introduction
            </h3>

            <p
              class="
                font-normal text-md md:text-base
                col-span-11 leading-normal w-full mt-2
              "
            >
              Cryptocurrencies, such as Bitcoin, Ethereum, and Litecoin, are digital currencies that operate
              independently of central banks. They offer enhanced privacy, lower transaction fees, and faster processing
              times. We embrace this revolutionary technology at <strong>Junglebet</strong>. This enables you to
              seamlessly integrate your crypto holdings into your ultimate gambling adventures. At
              <strong>Junglebet</strong>, we accept the following crypto currencies: Bitcoin, Ethereum, Litecoin,
              Bitcoin Cash, Stellar, Ripple, Solana, Binance Coin, Tron, Dogecoin, Shiba Inu, Matic, Chainlink, Cardano,
              Lido Staked Ether, Wrapped BTC, Wrapped ETH, Tether, USD Coin, Binance USD.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Embracing Crypto Across the Board
            </h3>

            <p
              class="
                font-normal text-md md:text-base
                col-span-11 leading-normal w-full mt-2
              "
            >
              There are a variety of online <strong>crypto betting</strong> and gambling platforms that accept crypto
              payments, but not all. Junglebet stands at the forefront of this movement. We accept a variety of popular
              cryptocurrencies. This includes Bitcoin, Ethereum, Litecoin, and more. By doing so, you are empowered to
              deposit and withdraw funds conveniently from around the world.
            </p>
          </SubHeaderWrapper>
          <div
            :class="cn('w-full max-w-[338px] md:max-w-[1011px] mx-auto pb-12')"
          >
            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Weighing the Pros and Cons of Crypto Gambling
            </h3>
            <p
              class="
                font-semibold text-md md:text-lg
                col-span-11 leading-normal w-full mt-2
              "
            >
              Benefits:
            </p>
            <div class="pl-10">
              <ol class="list-decimal">
                <li class="font-semibold text-md md:text-lg">
                  More Privacy
                  <p class="font-normal text-md md:text-base">
                    Using cryptocurrencies allows you to keep your personal and financial information private when
                    gambling online.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Faster Payments
                  <p class="font-normal text-md md:text-base">
                    Deposits and withdrawals with crypto happen faster than any traditional banking methods.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Lower Fees
                  <p class="font-normal text-md md:text-base">
                    You'll pay lower transaction fees when using cryptocurrencies, leaving more money for
                    <strong>crypto gambling</strong>.
                  </p>
                </li>
              </ol>
            </div>

            <p
              class="
                font-semibold text-md md:text-lg
                col-span-11 leading-normal w-full mt-2
              "
            >
              Potential Downsides:
            </p>
            <div class="pl-10">
              <ol class="list-decimal">
                <li class="font-semibold text-md md:text-lg">
                  Price Swings
                  <p class="font-normal text-md md:text-base">
                    The value of cryptocurrencies can vary signficantly, which means your deposited funds could gain or
                    lose value unexpectedly. You must always be aware of these risks when entering into the crypto
                    market.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Unclear Rules
                  <p class="font-normal text-md md:text-base">
                    A number of countries have unclear laws and regulations around the use of cryptocurrencies for
                    <strong>crypto betting</strong>. This is why you need to understand the rules and regulations within
                    your country to ensure safe gambling.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Technical Know-How is Needed
                  <p class="font-normal text-md md:text-base">
                    Learning how to properly use and manage cryptocurrencies requires some technical knowledge and care.
                    Junglebet is the main destination where you can both learn and enjoy this space safely. That’s why
                    we have a team of talented experts who ensure the environment is safe, secure and we educate our
                    players on a weekly basis.
                  </p>
                  <p class="font-normal text-md md:text-base">
                    At Junglebet, we want you to have all the facts upfront. Our team stays on top of the latest crypto
                    news and developments. This means we can always give you the expert guidance you need whether you
                    have any questions or concerns. Making informed decisions is crucial to us to ensure we provide an
                    enjoyable and secure gambling experience at Junglebet -
                    the ultimate <strong>online crypto casino</strong>.
                  </p>
                </li>
              </ol>
            </div>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Uncompromising Security and Fairness
            </h3>
            <p class="font-normal text-md md:text-base">
              At the core of our platform lies a commitment to trust and security. We employ state-of-the-art encryption
              technologies. For fair gameplay and generating random numbers, we partner with reputable third-party
              auditors. Our platform is regularly tested and certified for integrity. We give you the peace of mind you
              deserve while playing our thrilling <strong>casino crypto</strong>
              games and <strong>sports betting</strong> offerings.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Rewards and Bonuses
            </h3>
            <p class="font-normal text-md md:text-base">
              At Junglebet, we believe in rewarding our players, regardless of their preferred payment method. Whether
              you choose to deposit with cryptocurrencies or traditional payment options, you'll have access to our:
            </p>
            <div class="pl-10">
              <ul class="list-disc text-md md:text-base">
                <li>Welcome bonuses</li>
                <li>Reload bonuses</li>
                <li>VIP program</li>
                <li>Launch promotions</li>
                <li>Rakeback percentages</li>
              </ul>
            </div>
            <p class="font-normal text-md md:text-base">
              Our goal is to provide an unparalleled gaming experience that celebrates your loyalty.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              The Ultimate World of Online Games
            </h3>
            <p class="font-normal text-md md:text-base">
              At Junglebet, we've gathered the best collection of casino games for all crypto gaming and gambling fans.
              Get ready to explore:
            </p>

            <p
              class="
                font-semibold text-md md:text-lg
                col-span-11 leading-normal w-full mt-2
              "
            >
              Top Casino Classics:
            </p>
            <div class="pl-10">
              <ol class="list-decimal">
                <li class="font-semibold text-md md:text-lg">
                  Classic Table Games
                  <p class="font-normal text-md md:text-base">
                    Enjoy timeless favorites like Blackjack, Roulette, Baccarat, Poker, Craps, Dice, Texas Hold’em.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Slot Machines Games
                  <p class="font-normal text-md md:text-base">
                    Enjoy our huge selection of slot games like Sweet Bonanza, Sugar Rush, Wanted Dead or a Wild, Gates
                    of Olympus, Fruit Party, Rise of Merlin.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Video Poker Games
                  <p class="font-normal text-md md:text-base">
                    Test your poker skills in our video poker games, combining cards with digital fun.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Live Casino Games
                  <p class="font-normal text-md md:text-base">
                    Experience the true casino atmosphere from home with our live dealer games streamed in real-time.
                    Enjoy live casino games such as Live Blackjack, Live Roulette, Live Baccarat, Live Poker.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Junglebet Originals
                  <p class="font-normal text-md md:text-base">
                    Enjoy Junglebet’s in-house casino games, Junglebet Originals such as Plinko, Dice, Snake Escape,
                    Blackjack, Keno, Mines, HiLo, Slots, Limbo, Crash, Coin Flip, Roulette, Double or Nothing, Spin
                    Boost and Wheel Spin.
                  </p>
                </li>
              </ol>
            </div>

            <p
              class="
                font-semibold text-md md:text-lg
                col-span-11 leading-normal w-full mt-2
              "
            >
              Sports Betting:
            </p>
            <div class="pl-10">
              <ol class="list-decimal">
                <li class="font-semibold text-md md:text-lg">
                  All The Sports
                  <p class="font-normal text-md md:text-base">
                    Our online crypto sportsbook covers tons of popular Sports and Esports leagues, tournaments and
                    events from around the world. Enjoy betting on top sports such as Soccer, American Football,
                    Basketball, Ice Hockey, Hockey, Gold, Fútbol, Futsal, Volleyball, Table Tennis, Tennis, Formula 1,
                    Darts, and Squash. Enjoy a variety of of Esports games such as Counter Strike, Valorant, eTennis,
                    Data 2, League of Legends, eRocket League, FIFA: Volta, eHorse Racing, Penalty Shootout, eFighting,
                    NBA 2k, eRocket League, eCricket, eBaseball, eShooter, King of Glory, Mobile Legends, Call of Duty,
                    Overwatch, WarCraft III, FIFA eSoccer.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Bet with Crypto
                  <p class="font-normal text-md md:text-base">
                    Place bets using your favorite cryptocurrency for extra privacy and fast payments.
                  </p>
                </li>
                <li class="font-semibold text-md md:text-lg">
                  Great Odds
                  <p class="font-normal text-md md:text-base">
                    We offer competitive odds, so you get great value when betting on your favorite teams and players.
                  </p>
                  <p class="font-normal text-md md:text-base">
                    No matter whether you're a high-roller or just playing for fun, Junglebet offers the ultimate game
                    lineup that'll keep you entertained. Don’t miss this ultimate experience of crypto gambling!
                  </p>
                </li>
              </ol>
            </div>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Seamless Gaming on the Go
            </h3>
            <p class="font-normal text-md md:text-base">
              Junglebet is designed to provide a seamless gaming experience across all devices. Our user-friendly
              platform is fully optimized for mobile and tablet use. This ensures that you can enjoy your favorite
              casino games and sports betting action on the go, from around the world.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Effortless Banking Experience
            </h3>
            <p class="font-normal text-md md:text-base">
              At Junglebet, we pride ourselves on offering a hassle-free banking experience. Depositing and withdrawing
              funds from cryptocurrencies is quick, secure, and straightforward. Our user-friendly interface walks you
              through the steps. This will make it easier for you to manage your transactions. Additionally, our
              dedicated customer support team is available 24/7 to assist you with any questions or concerns you may
              have.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              Choosing the Right Crypto Casino
            </h3>
            <p class="font-normal text-md md:text-base">
              When selecting a crypto casino, security, fair gameplay, and a wide range of game offerings should be at
              the forefront of your considerations. At Junglebet, we tick all these boxes and more.
            </p>
            <p class="text-md md:text-base w-full text-center font-bold underline">
              Our platform is regularly audited for fairness
            </p>
            <p class="text-md md:text-base w-full text-center font-bold underline mt-2">
              Our games are Provably Fair
            </p>
            <p class="text-md md:text-base w-full text-center font-bold underline mt-2">
              Our wide selection of crypto-friendly games is unparalleled
            </p>
            <p class="font-normal text-md md:text-base mt-2">
              Additionally, we offer competitive odds, generous bonuses, and a commitment to responsible gambling
              practices.
            </p>
            <p class="font-normal text-md md:text-base">
              Experience the future of online gambling and sports betting with Junglebet. Let us show you what we are
              all about, where gamification and security go hand in hand at the <strong>best crypto casino</strong>.
            </p>
            <p class="font-normal text-md md:text-base mt-2 md:mt-5">
              Join us today and see what we are all about.
            </p>

            <h3
              class="
                text-lg md:text-xl font-semibold text-highlights
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              FAQs:
            </h3>

            <div class="grid grid-cols-3 gap-3 md:gap-4 w-full mt-2">
              <div class="col-span-3 sm:col-span-1 border border-paragraph rounded-sm p-2 md:p-4">
                <h3 class="font-bold text-base">
                  Why choose Junglebet for crypto gambling?
                </h3>

                <p class="font-normal text-md md:text-base mt-2">
                  Junglebet offers top-notch security, accepts various cryptocurrencies, ensures faster transactions,
                  and provides extensive game selection for an unmatched online gambling experience.
                </p>
              </div>
              <div class="col-span-3 sm:col-span-1 border border-paragraph rounded-sm p-2 md:p-4">
                <h3 class="font-bold text-base">
                  In what ways can I be sure Junglebet's platform is fair and secure?
                </h3>

                <p class="font-normal text-md md:text-base mt-2">
                  Junglebet employs cutting-edge encryption, undergoes regular audits for Provably Fair gameplay, and
                  provides transparent policies and round-the-clock customer support for a secure and trustworthy
                  gambling experience.
                </p>
              </div>
              <div class="col-span-3 sm:col-span-1 border border-paragraph rounded-sm p-2 md:p-4">
                <h3 class="font-bold text-base">
                  Is Junglebet accessible on mobile devices?
                </h3>

                <p class="font-normal text-md md:text-base mt-2">
                  Absolutely, Junglebet is fully optimized for mobile and tablet use, providing a seamless gaming
                  experience on the go. Enjoy your favorite casino games and sports betting action wherever you are.
                </p>
              </div>
            </div>

            <p class="font-normal text-md md:text-base mt-2 md:mt-5">
              <strong>Keywords:</strong>
              Junglebet, Jungle bet, crypto casino, crypto gambling, best crypto casino, crypto betting,
              online crypto casino, casino crypto, crypto sports betting
            </p>
          </div>
        </ContentWrapper>
      </ContentContainer>
    </SectionWrapper>

    <Icons :class="cn('absolute bottom-0 left-0')" />
  </SectionContainer>
</template>
